import { useSelector } from "react-redux";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { useQuery } from "@tanstack/react-query";
import { NETWORKING_RECOMMENDATIONS_USERS_QUERY_KEY } from "modules/registration/constants";
import { selectCurrentEvent } from "modules/event/selectors";
import { selectUserId } from "modules/auth/redux/selectors";
import { useEffect } from "react";
import { Errors, trackError } from "modules/monitoring";
import { selectNetworkIsConnected } from "modules/network/redux/selectors";
import { useAppDispatch } from "store/hooks";
import { setNetworkingRecommendations } from "modules/networkingRecommendations/redux/slice";
import { getNetworkingRecommendation } from "modules/registration/hooks/useNetworkingRecommendationsOperations/request";

export const NetworkingRecommendations = () => {
  const isConnected = useSelector(selectNetworkIsConnected);
  const event = useSelector(selectCurrentEvent);
  const userId = useSelector(selectUserId);
  const { addErrorNotification } = useNotificationActions();
  const dispatch = useAppDispatch();

  const { error, data } = useQuery({
    queryKey: [NETWORKING_RECOMMENDATIONS_USERS_QUERY_KEY, event?.id, userId],
    queryFn: async () => {
      if (!event?.id || !event?.isNetworkingRecommendationsEnabled) return [];
      if (!userId) return [];
      return getNetworkingRecommendation(event.id);
    },

    enabled:
      isConnected && event?.id && event?.isNetworkingRecommendationsEnabled,
  });

  useEffect(() => {
    if (error) {
      trackError(error, {
        label: Errors.NETWORKING_RECOMMENDATIONS_USERS,
        eventId: event?.id,
      });
    }
  }, [addErrorNotification, error, event?.id]);

  useEffect(() => {
    if (data) {
      dispatch(setNetworkingRecommendations(data));
    }
  }, [data, dispatch]);

  return null;
};
